module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-82.18a18d58.svg";